import ReactOnRails from "react-on-rails";
import SharePercentApp from "./bundles/SharePercentApp";
import NotificationsApp from "./bundles/NotificationsApp";
import TimelineApp from "./bundles/TimelineApp";
import ActivityApp from "./bundles/ActivityApp";
import CampaignEventInviteApp from "./bundles/CampaignEventInviteApp";
import LeaveCampaignApp from "./bundles/LeaveCampaignApp";
import UserFundsApp from "./bundles/UserFundsApp";
import SwitchTeamApp from "./bundles/SwitchTeamApp";
import TeamsnapConnectApp from "./bundles/TeamsnapConnectApp";
import StoreApp from "./bundles/StoreApp";
import CampaignBeneficiaryApp from "./bundles/CampaignBeneficiaryApp";
import AudienceFiltersApp from "./bundles/AudienceFiltersApp";
import ProgramCreationApp from "./bundles/ProgramCreationApp";

ReactOnRails.register({
  SharePercentApp,
  NotificationsApp,
  TimelineApp,
  ActivityApp,
  CampaignEventInviteApp,
  UserFundsApp,
  LeaveCampaignApp,
  SwitchTeamApp,
  TeamsnapConnectApp,
  StoreApp,
  CampaignBeneficiaryApp,
  AudienceFiltersApp,
  ProgramCreationApp,
});
